"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContactInfo_1 = __importDefault(require("./ContactInfo"));
const IdentityInfo_1 = __importDefault(require("./IdentityInfo"));
const constants_1 = require("../constants");
class StateLeg {
    // email: PString;
    // biography: PString;
    // birth_date: PString;
    // death_date: PString;
    constructor(data) {
        const current_chamber = data.current_chamber;
        const type = current_chamber === "upper" ? constants_1.LegislatorTypes.SLDU : constants_1.LegislatorTypes.SLDL;
        this.API_ID = constants_1.parsePString(data?.id);
        this.firstName = constants_1.parsePString(data?.given_name);
        this.lastName = constants_1.parsePString(data?.family_name);
        this.fullName = constants_1.parsePString(data?.name);
        this.gender = constants_1.parsePString(data?.gender);
        this.party = parseParty(data?.current_party);
        this.image = constants_1.parsePString(data?.image);
        this.title =
            type === constants_1.LegislatorTypes.SLDL
                ? `${data.stateAbbrev} Lower Chamber`
                : `${data.stateAbbrev} Upper Chamber`;
        this.identityInfo = new IdentityInfo_1.default(type, data?.stateAbbrev, data?.current_district, data?.current_chamber, data?.GEOID ? data.GEOID : "", null, data.id);
        this.contactInfo = new ContactInfo_1.default(constants_1.PersonTypes.STATE_LEG, data);
    }
}
exports.default = StateLeg;
function parseParty(unparsed) {
    if (unparsed === undefined)
        return null;
    if (unparsed === null)
        return null;
    unparsed = unparsed.toLowerCase();
    if (unparsed === "democratic")
        return constants_1.PartyEnum.Democrat;
    else if (unparsed === "republican")
        return constants_1.PartyEnum.Republican;
    else
        return unparsed;
}
